// position
export const JAVA_FULL_STACK_DEVELOPER = "Java Full Stack Developer";
export const REACT_FULL_STACK_DEVELOPER = "React Full Stack Developer";
export const HTML_CODER = "HTML coder";
